var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInfoMedium = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "F6AF2868-AE19-4786-9A8D-DD0D0470A7AD@2x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eligibility-Check",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "000_Asset_downloads",
    transform: "translate(-125.000000, -371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(101.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Styles/UI-icons/medium/icon-info-medium",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "bl-icon_information-grey-medium",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,16 C32,24.8344615 24.8332308,32 16,32 C7.16430769,32 0,24.8344615 0,16 C0,7.16430769 7.16430769,0 16,0 C24.8332308,0 32,7.16430769 32,16 Z",
    id: "Shape",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6708208,9.64804135 C14.6733234,8.42711827 15.672708,7.43881058 16.8960926,7.44615408 C18.1231696,7.4498875 19.1090157,8.44804135 19.1016723,9.6738875 C19.096708,10.8948106 18.099785,11.884349 16.8751696,11.8770055 C15.651785,11.8720414 14.6634773,10.8738875 14.6708208,9.64804135 Z M17.9250157,23.292349 C17.107785,23.3157337 16.819785,23.0412721 16.9219388,22.2289644 C17.0216311,21.4449644 17.235785,20.6781952 17.4056311,19.9040414 C17.6542465,18.7680414 18.0124003,17.644349 18.1305542,16.4960414 C18.259785,15.2086567 17.3010157,14.3175798 15.9988619,14.252349 C15.0290157,14.2031183 14.1428619,14.4972721 13.240708,14.7951183 C12.6770157,14.9797337 12.4874773,15.3305029 12.4924003,15.8978875 C12.9133234,15.8338875 13.304708,15.7440414 13.7010157,15.7231183 C14.515785,15.676349 14.8382465,15.9877337 14.7619388,16.8061952 C14.7102465,17.3575798 14.5650157,17.9015798 14.4382465,18.4418875 C14.1391696,19.7415798 13.7330157,21.0228106 13.5434773,22.3360414 C13.3416311,23.7452721 14.2622465,24.6585029 15.6813234,24.7668106 C16.696708,24.8455798 17.5988619,24.4972721 18.5330157,24.204349 C19.1225542,24.0172721 19.2013234,23.644349 19.192708,23.1385029 C18.7496311,23.1951183 18.3385542,23.2812721 17.9250157,23.292349 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoMedium, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-medium.e6d4acb5.svg";
export { ForwardRef as ReactComponent };